import request from "@/utils/request";

// 查询用户信息
export function getInfo(id) {
  return request({
    url: '/user/customer/' + id,
    method: 'get',
  })
}
// 修改用户信息
export function updateInfo(data) {
  return request({
    url: '/user/customer/h5/update',
    method: 'post',
    data
  })
}
// 获取 我的-喜欢的发现
export function getMineLike(params) {
  return request({
    url: '/setting/fodder/h5/article',
    method: 'get',
    params
  })
}